import axios from 'axios';
import api from './api';

const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').trim().replace(/\/$/, '');

// Team side: Harbour Master -> Clients
export const clientsAPI = {
  list: () => api.get('/api/clients'),
  invite: (data) => api.post('/api/clients', data),
  resend: (id) => api.post(`/api/clients/${id}/resend`),
  inviteLink: (id) => api.get(`/api/clients/${id}/invite-link`),
  update: (id, data) => api.patch(`/api/clients/${id}`, data),
  remove: (id) => api.delete(`/api/clients/${id}`),
};

// Client portal: its own sign-in, kept apart from the team login
const KEY = 'stagehead_client_token';
export const clientSession = {
  get: () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
  set: (t) => { try { localStorage.setItem(KEY, t); } catch (e) { /* ignore */ } },
  clear: () => { try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ } },
};

const pub = axios.create({ baseURL: API_BASE_URL });
pub.interceptors.request.use((config) => {
  const t = clientSession.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const portalAPI = {
  inviteInfo: (token) => pub.get(`/api/client-auth/invite/${token}`),
  acceptInvite: (token, data) => pub.post(`/api/client-auth/invite/${token}`, data),
  login: (email, password) => pub.post('/api/client-auth/login', { email, password }),
  resetRequest: (email) => pub.post('/api/client-auth/reset-request', { email }),
  reset: (token, password) => pub.post('/api/client-auth/reset', { token, password }),
  me: () => pub.get('/api/portal/me'),
  overview: () => pub.get('/api/portal/overview'),
  startYarn: (data) => pub.post('/api/portal/yarns', data),
};
